const pathRoutes = {
  PORTAL: 'portalMyedu',
  ADMIN: 'admin',
};

export default pathRoutes;
